var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPLOAD_IMAGE_BY_CARRIER_REQUEST, uploadImageByCarrierSuccess, uploadImageByCarrierFailure, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const UploadImageByCarrier = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const { tenantId, carrierRejectfile } = action.payload;
        try {
            APIIN.formUpload(`/report/admin/weight/dispute/batch/carrier/upload?tenantId=${tenantId}`, {
                carrierRejectfile: carrierRejectfile,
            })
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            reject(error);
        }
    }));
});
function* uploadImageByCarrierWorker(action) {
    try {
        const response = yield call(UploadImageByCarrier, action);
        yield put(uploadImageByCarrierSuccess(response));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            yield put(uploadImageByCarrierFailure(error.response.data.message));
        }
        else {
            yield put(uploadImageByCarrierFailure("An error occurred while uploading the file"));
        }
    }
}
export function* watchUploadImageByCarrier() {
    yield takeLatest(UPLOAD_IMAGE_BY_CARRIER_REQUEST, uploadImageByCarrierWorker);
}
